module.exports = __webpack_public_path__ + "static/media/youthsong.b6c2c92a.png";